import { Locale, type LocalizedString } from "../Locale.js";
import { SoldOutLabel } from "../SoldOutLabel.js";

export const soldOutLabelNameMap = {
	[SoldOutLabel.Unavailable]: {
		[Locale.cs]: "Aktuálně nedostupné",
	},
	[SoldOutLabel.SoldOut]: {
		[Locale.cs]: "Aktuálně vyprodáno",
	},
} satisfies Record<SoldOutLabel, LocalizedString>;
